export let life = {}
export let event = {
  gobackClick () {
    this.methods('goBack')
  }
}
export let watch = {}
